/* src/app/feature-modules/lessons/components/lesson-details/lesson-details.component.css */
.image-preview img {
  max-width: 100%;
  max-height: 100%;
}
/*# sourceMappingURL=lesson-details.component.css.map */
